import Vue from "vue";
import {get, isNil} from "lodash";
import isFilledJSONValue from '../../helpers/isFilledJSONValue';
import getInputsValue from './common/getInputsValue'
import getInputsComplete from './common/getInputsComplete';
import { setDefaultInputsValues, setDefaultInputsDisabled } from './common/setDefaultInputs';
import filterDisabled from './common/filterDisabled';
import {http} from "@/axios";

function getInitState() {
  return {
    muted: false,
    pendingSave: false,
    sectionId: 3,

    photoAndVideoFiles: [],
    photoAndVideoFilesPending: false,
    photoAndVideoFilesEditPending: false,
    photoAndVideoFilesError: null,

    additionalDocument: [],
    additionalDocumentPending: false,
    additionalDocumentError: null,

    companyLogo: null,
    companyLogoPending: false,
    companyLogoError: null,

    // - -

    workPaceFiles: [],
    workPaceFilesPending: false,
    workPaceFilesEditPending: false,
    workPaceFilesError: null,

    // - -

    workPaceConditionsFiles: [],
    workPaceConditionsFilesPending: false,
    workPaceConditionsFilesEditPending: false,
    workPaceConditionsFilesError: null,

    // - -

    workPaceProcedureFiles: [],
    workPaceProcedureFilesPending: false,
    workPaceProcedureFilesEditPending: false,
    workPaceProcedureFilesError: null,

    // - -

    inputs: {
      about: {
        value: null,
        required: true,
        check: (state) => {
          return isFilledJSONValue(state.inputs.about.value)
        }
      },
      work_place_name: {
        value: null,
        required: true,
        check: (state) => {
          return !!state.inputs.work_place_name.value
        }
      },
      work_place_logo: {
        value: null,
      },
      // work_place_code: {
      //   value: null,
      //   check: (state) => {
      //     return !!state.inputs.work_place_code.value
      //   }
      // },
      work_place_address: {
        value: null,
        // check: (state) => {
        //   return !!state.inputs.work_place_address.value
        // }
      },
      work_place_country: {
        value: null,
        required: true,
        check: (state) => {
          return !!state.inputs.work_place_country.value
        }
      },
      work_place_city: {
        value: null,
        check: (state) => {
          return !!state.inputs.work_place_city.value
        }
      },
      work_place_description: {
        value: null,
        check: (state) => {
          return isFilledJSONValue(state.inputs.work_place_description.value)
        }
      },
      // work_place_conditions: {
      //   value: null,
      //   check: (state) => {
      //     return isFilledJSONValue(state.inputs.work_place_conditions.value)
      //   }
      // },
      work_place_procedures: {
        value: null,
        check: (state) => {
          return isFilledJSONValue(state.inputs.work_place_procedures.value)
        }
      },
      features_1: {
        value: null,
        check: (state) => {
          return isFilledJSONValue(state.inputs.features_1.value)
            || isFilledJSONValue(state.inputs.features_1_description.value)
        }
      },
      features_1_description: {
        value: null,
      },
      features_2: {
        value: null,
        check: (state) => {
          return isFilledJSONValue(state.inputs.features_2.value)
            || isFilledJSONValue(state.inputs.features_2_description.value)
        }
      },
      features_2_description: {
        value: null,
      },
      features_3: {
        value: null,
        check: (state) => {
          return isFilledJSONValue(state.inputs.features_3.value)
            || isFilledJSONValue(state.inputs.features_3_description.value)
        }
      },
      features_3_description: {
        value: null,
      },
    },
  }
}

export default {
  namespaced: true,
  modules: {},
  state: getInitState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setProperty(state, [key, value]) {
      if (!state.hasOwnProperty(key)) return

      Vue.set(state, key, value)
    },
    setFilePhotoAndVideoProperty(state, [index, value]) {
      Vue.set(state.photoAndVideoFiles[index], 'caption', value)
    },
    setInputValue(state, [key, value]) {
      Vue.set(state.inputs[key], 'value', value)
    },
    setDefaultInputsValues,
    setDefaultInputsDisabled,
    setInputError(state, [key, error]) {
      Vue.set(state.inputs[key], 'error', error)
    },
    setInputDisabled(state, [key, disabled]) {
      Vue.set(state.inputs[key], 'disabled', disabled);
    },
    setInputsAll(state, data) {
      const sectionData = data[3]

      for (const key in state.inputs) {
        const inputObj = state.inputs[key]

        if (Array.isArray(inputObj)) {
          Vue.set(state.inputs, key, sectionData[key] || [])
        } else if (!isNil(sectionData[key])) {
          Vue.set(inputObj, 'value', sectionData[key])
        }
      }

      state.companyLogo = sectionData.company_logo
      state.additionalDocument = sectionData.files || []
      state.photoAndVideoFiles = sectionData.images || []

      state.workPaceFiles = data.galleries.work_place_files
      state.workPaceConditionsFiles = data.galleries.work_place_conditions_files
      state.workPaceProcedureFiles = data.galleries.work_place_procedure_files

      // const duplicateId = store.state.vacancyEdit.duplicateId
      // if (duplicateId) {
      //   [
      //     state.companyLogo,
      //     ...state.additionalDocument,
      //     ...state.photoAndVideoFiles
      //   ].forEach(file => {
      //     Vue.set(file, 'is_copy', true)
      //     Vue.set(file, 'copy_vacancy_id', duplicateId)
      //   })
      // }

    },
    removeDefaultCompanyLogo(state) {
      state.inputs.work_place_logo.value = null;
    },
  },
  actions: {
    uploadAfterDuplicate({rootState, state, commit}) {
      const files = state.additionalDocument.map(f => f.id)
      const media = state.photoAndVideoFiles.map(f => f.id)

      if (
          !get(state, 'companyLogo.id')
          && !media.length
          && !files.length
      ) return

      const {vacancy, duplicateId} = rootState.vacancyEdit
      const vacancyId = vacancy && vacancy.id

      const sendData = {
        company_logo: get(state, 'companyLogo.id'),
        images: media.length ? files : null,
        files: files.length ? files : null,
        duplicate_vacancy_id: duplicateId
      }

      http.post(`/api/vacancy/${vacancyId}/add-duplicated-files-media`, sendData)
          .then(({data}) => {
            const {
              company_logo,
              images,
              files,
            } = data.data[3]


            commit('setProperty', ['companyLogo', company_logo || null])
            commit('setProperty', ['photoAndVideoFiles', images || []])
            commit('setProperty', ['additionalDocument', files || []])
          })
    },

    uploadAdditionalFiles({state, commit, rootState}, files) {
      const {vacancy} = rootState.vacancyEdit
      const vacancyId = vacancy && vacancy.id

      commit('setProperty', ['additionalDocumentError', null])
      commit('setProperty', ['additionalDocumentPending', true])

      const sendData = new FormData()
      for (const file of files) {
        sendData.append('files[]', file)
      }

      return http.post(`/api/vacancy/${vacancyId}/files`, sendData).then(({data}) => {
        const newFilesArray = state.additionalDocument.concat(data.data)
        commit('setProperty', ['additionalDocument', newFilesArray])
      }).catch((error) => {
        commit('setProperty', ['additionalDocumentError', getResponseErrorMessage(error)])
      }).finally(() => {
        commit('setProperty', ['additionalDocumentPending', false])
      })
    },
    deleteAdditionalFiles({state, commit, rootState}, id) {
      commit('setProperty', ['additionalDocumentError', null])

      const {vacancy} = rootState.vacancyEdit
      const vacancyId = vacancy && vacancy.id
      const newAdditionalDocument = state.additionalDocument.filter(item => item.id !== id)

      const fileToDelete = state.additionalDocument.find(f => f.id === id)
      if (fileToDelete.is_copy) {
        return commit('setProperty', ['additionalDocument', newAdditionalDocument])
      }

      commit('setProperty', ['additionalDocumentPending', true])

      http.delete(`/api/vacancy/${vacancyId}/file/${id}`).then(() => {
        commit('setProperty', ['additionalDocument', newAdditionalDocument])
      }).catch((error) => {
        commit('setProperty', ['additionalDocumentError', getResponseErrorMessage(error)])
      }).finally(() => {
        commit('setProperty', ['additionalDocumentPending', false])
      })
    },
    uploadPhotoAndVideo({state, commit, rootState}, files) {
      commit('setProperty', ['photoAndVideoFilesError', null])
      commit('setProperty', ['photoAndVideoFilesPending', true])

      const formData = new FormData()
      const {vacancy} = rootState.vacancyEdit
      const vacancyId = vacancy && vacancy.id

      files.forEach((file) => {
        formData.append(`files[]`, file)
      })

      http.post(`api/new-vacancy/${vacancyId}/media`, formData).then(({data}) => {
        const newFilesArray = state.photoAndVideoFiles.concat(data.data)
        commit('setProperty', ['photoAndVideoFiles', newFilesArray])
      }).catch((error) => {
        commit('setProperty', ['photoAndVideoFilesError', getResponseErrorMessage(error)])
      }).finally(() => {
        commit('setProperty', ['photoAndVideoFilesPending', false])
      })
    },
    deleteFilePhotoAndVideo({state, commit, rootState}, index) {
      commit('setProperty', ['photoAndVideoFilesError', null])
      commit('setProperty', ['photoAndVideoFilesEditPending', true])

      const id = state.photoAndVideoFiles[index].id
      const newFiles = state.photoAndVideoFiles.filter(item => item.id !== id)
      const {vacancy} = rootState.vacancyEdit
      const vacancyId = vacancy && vacancy.id
      debugger

      if (state.photoAndVideoFiles[index].is_copy) {
        return commit('setProperty', ['photoAndVideoFiles', newFiles])
      }

      commit('setProperty', ['photoAndVideoFilesEditPending', true])

      http.delete(`api/new-vacancy/${vacancyId}/media/${id}`).then(() => {
        commit('setProperty', ['photoAndVideoFiles', newFiles])
      }).catch((error) => {
        commit('setProperty', ['photoAndVideoFilesError', getResponseErrorMessage(error)])
      }).finally(() => {
        commit('setProperty', ['photoAndVideoFilesEditPending', false])
      })
    },
    updatePhotoAndVideo({state, commit, rootState}, value) {
      commit('setProperty', ['photoAndVideoFilesError', null])
      commit('setProperty', ['photoAndVideoFilesEditPending', true])

      const prevValue = state.photoAndVideoFiles
      const {vacancy} = rootState.vacancyEdit
      const vacancyId = vacancy && vacancy.id
      const sendArray = value.map(item => {
        return {
          id: item.id,
          title: item.title
        }
      })

      commit('setProperty', ['photoAndVideoFiles', value])
      http.put(`api/new-vacancy/${vacancyId}/media`, sendArray).then().catch((error) => {
        commit('setProperty', ['photoAndVideoFiles', prevValue])
        commit('setProperty', ['photoAndVideoFilesError', getResponseErrorMessage(error)])
      }).finally(() => {
        commit('setProperty', ['photoAndVideoFilesEditPending', false])
      })
    },

    uploadCompanyLogo({commit, rootState}, file) {
      commit('setProperty', ['companyLogoError', null])
      commit('setProperty', ['companyLogoPending', true])

      const {vacancy} = rootState.vacancyEdit
      const vacancyId = vacancy && vacancy.id
      const formData = new FormData()
      formData.append('file', file)

      return http.post(`api/new-vacancy/${vacancyId}/company_logo`, formData).then(({data}) => {
        commit('setProperty', ['companyLogo', data.data])
      }).catch((error) => {
        commit('setProperty', ['companyLogoError', getResponseErrorMessage(error)])
      }).finally(() => {
        commit('setProperty', ['companyLogoPending', false])
      })
    },
    deleteCompanyLogo({commit, rootState, state}) {
      if (state.inputs.work_place_logo.value) return commit('removeDefaultCompanyLogo');

      commit('setProperty', ['companyLogoError', null])
      commit('setProperty', ['companyLogoPending', true])

      const {vacancy} = rootState.vacancyEdit
      const vacancyId = vacancy && vacancy.id

      if (state.companyLogo.is_copy) {
        return commit('setProperty', ['companyLogo', null])
      }

      return http.delete(`api/new-vacancy/${vacancyId}/company_logo`).then(() => {
        commit('setProperty', ['companyLogo', null])
      }).catch((error) => {
        commit('setProperty', ['companyLogoError', getResponseErrorMessage(error)])
      }).finally(() => {
        commit('setProperty', ['companyLogoPending', false])
      })
    },

    uploadFilesByKey({state, commit, rootState}, [key, urlName, files]) {
      commit('setProperty', [`${key}Error`, null])
      commit('setProperty', [`${key}Pending`, true])

      const formData = new FormData()
      const {vacancy} = rootState.vacancyEdit
      const vacancyId = vacancy && vacancy.id

      files.forEach((file) => {
        formData.append(`files[]`, file)
      })

      http.post(`api/new-vacancy/${vacancyId}/${urlName}`, formData).then(({data}) => {
        const newFilesArray = state[key].concat(data.data)
        commit('setProperty', [key, newFilesArray])
      }).catch((error) => {
        commit('setProperty', [`${key}Error`, getResponseErrorMessage(error)])
      }).finally(() => {
        commit('setProperty', [`${key}Pending`, false])
      })
    },
    deleteFilesByKey({state, commit, rootState}, [key, urlName, index]) {
      commit('setProperty', [`${key}Error`, null])
      commit('setProperty', [`${key}EditPending`, true])

      const id = state[key][index].id
      const {vacancy} = rootState.vacancyEdit
      const vacancyId = vacancy && vacancy.id

      http.delete(`api/new-vacancy/${vacancyId}/${urlName}/${id}`).then(() => {
        const newFiles = state[key].filter(item => item.id !== id)
        commit('setProperty', [key, newFiles])
      }).catch((error) => {
        commit('setProperty', [`${key}Error`, getResponseErrorMessage(error)])
      }).finally(() => {
        commit('setProperty', [`${key}EditPending`, false])
      })
    },
    updateFilesByKey({state, commit, rootState}, [key, urlName, value]) {
      commit('setProperty', [`${key}Error`, null])
      commit('setProperty', [`${key}EditPending`, true])

      const prevValue = state[key]
      const {vacancy} = rootState.vacancyEdit
      const vacancyId = vacancy && vacancy.id
      const sendArray = value.map(item => {
        return {
          id: item.id,
          title: item.title
        }
      })

      commit('setProperty', [key, value])
      http.put(`api/new-vacancy/${vacancyId}/${urlName}`, sendArray).catch((error) => {
        commit('setProperty', [key, prevValue])
        commit('setProperty', [`${key}Error`, getResponseErrorMessage(error)])
      }).finally(() => {
        commit('setProperty', [`${key}EditPending`, false])
      })
    },

    setSectionErrors({state, commit}, { errors }) {
      if (typeof errors !== 'object') {
        errors = {}
      } else {
        errors = JSON.parse(JSON.stringify(errors))
      }

      for (const key in state.inputs) {
        if (Array.isArray(state.inputs[key])) {
          state.inputs[key].forEach((item, index) => {
            commit('setArrayInputError', [key, index, 'phone', errors[key]])
          })
        } else {
          commit('setInputError', [key, errors[key]])
        }

        delete errors[key]
      }
    },
  },
  getters: {
    complete(state) {
      let mustFilledCount = 0
      let filledCount = 0

      mustFilledCount++
      if (state.photoAndVideoFiles.length > 0) {
        filledCount++
      }

      mustFilledCount++
      if (state.additionalDocument.length > 0) {
        filledCount++
      }

      const inputs = state.inputs

      const result = getInputsComplete(state, inputs)
      mustFilledCount += result.mustFilledCount
      filledCount += result.filledCount

      return Math.round(100 / mustFilledCount * filledCount)
    },
    sendData(state) {
      const data = getInputsValue(state.inputs);

      return filterDisabled(data, state.inputs);
    }
  }
}

function getResponseErrorMessage(error) {
  return error.response && error.response.data && error.response.data.message ||
      error.response && error.response.message ||
      error.toString()
}
